import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils";
import ExperimentationGroupResourceV2 from "@ane/exp-data/lib/resources/expapiunified/ExperimentationGroup.resource";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import DataplaneResource from "../../../resources/DataplaneResources.js";
import { AnalysisConfigRouteUtils } from "@ane/exp-data/lib/routes/AnalysisConfigRoute.utils";
import NavigationService from "@ane/core/lib/services/NavigationService";
import AnalysisTemplateResource from "../../../resources/AnalysisTemplateResource.js";
const prefix = "ANALYSIS_CONFIG_CREATE";
const experimentationGroupsPrefix = `${prefix}/EXPERIMENTATION_GROUPS`;
const assignmentUnitsPrefix = `${prefix}/ASSIGNMENT_UNITS`;
const analysisTemplatesPrefix = `${prefix}/ANALYSIS_TEMPLATES`;
const rootExperimentationGroupPrefix = `${prefix}/ROOT_EXPERIMENTATION_GROUP`;
const createAnalysisRulePrefix = `${prefix}/CREATE_ANALYSIS_RULE`;
const loadExperimentationGroupsEpicReducerArgs = {
  actionPrefix: experimentationGroupsPrefix,
  reduxKeyNested: () => ["experimentationGroups"],
  loadResource: (workspaceId) => {
    return ExperimentationGroupResourceV2.getExperimentationGroups(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.value;
  }
};
const loadExperimentationGroupsEpicReducer = loadResourcesUtils(loadExperimentationGroupsEpicReducerArgs);
const loadAssignmentUnitsEpicReducerArgs = {
  actionPrefix: assignmentUnitsPrefix,
  reduxKeyNested: () => ["assignmentUnits"],
  loadResource: (workspaceId) => {
    return AssignmentUnitsResource.getAssignmentUnits(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.value;
  }
};
const loadAssignmentUnitsEpicReducer = loadResourcesUtils(loadAssignmentUnitsEpicReducerArgs);
const getLoadAssignmentUnitsEpicReducer = () => loadAssignmentUnitsEpicReducer;
const loadAnalysisTemplatesEpicReducerArgs = {
  actionPrefix: analysisTemplatesPrefix,
  reduxKeyNested: () => ["analysisTemplates"],
  loadResource: (workspaceId) => {
    return AnalysisTemplateResource.getAnalysisTemplatesNames(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadAnalysisTemplatesEpicReducer = loadResourcesUtils(loadAnalysisTemplatesEpicReducerArgs);
const loadRootExperimentationGroupEpicReducerArgs = {
  actionPrefix: rootExperimentationGroupPrefix,
  reduxKeyNested: () => ["rootExperimentationGroup"],
  loadResource: (workspaceId) => {
    return DataplaneResource.getRootExperimentationGroup(workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadRootExperimentationGroupEpicReducer = loadResourcesUtils(loadRootExperimentationGroupEpicReducerArgs);
const createAnalysisRuleEpicReducerInputArg = {
  actionPrefix: createAnalysisRulePrefix,
  reduxKeyNested: () => ["createAnalysisRule"],
  loadResource: (inputPayload) => DataplaneResource.createOrUpdateAnalysisRule(
    inputPayload.workspaceId,
    inputPayload.analysisRuleName,
    inputPayload.analysisRule
  ),
  onCompleteSuccess: (result) => {
    NavigationService.navigateTo(AnalysisConfigRouteUtils.routes.list.url());
    return result;
  }
};
const createAnalysisRuleEpicReducer = loadResourcesUtils(createAnalysisRuleEpicReducerInputArg);
const Create_epics = combineEpics(
  loadExperimentationGroupsEpicReducer.epic,
  loadRootExperimentationGroupEpicReducer.epic,
  createAnalysisRuleEpicReducer.epic,
  loadAssignmentUnitsEpicReducer.epic,
  loadAnalysisTemplatesEpicReducer.epic
);
export {
  analysisTemplatesPrefix,
  assignmentUnitsPrefix,
  createAnalysisRuleEpicReducer,
  createAnalysisRulePrefix,
  Create_epics as default,
  experimentationGroupsPrefix,
  getLoadAssignmentUnitsEpicReducer,
  loadAnalysisTemplatesEpicReducer,
  loadAssignmentUnitsEpicReducer,
  loadExperimentationGroupsEpicReducer,
  loadRootExperimentationGroupEpicReducer,
  prefix,
  rootExperimentationGroupPrefix
};
//# sourceMappingURL=Create.epics.js.map
